var generateStyle = function generateStyle(componentTheme, props) {
  return {
    stimulus: {
      paddingTop: componentTheme.stimulusPadding,
      paddingBottom: componentTheme.stimulusPadding
    },
    footer: {
      display: 'flex',
      justifyContent: 'flex-end'
    },
    buttonWrapper: {
      paddingLeft: componentTheme.buttonWrapperPadding
    },
    header: {
      height: '1rem',
      paddingLeft: componentTheme.headerPadding,
      paddingRight: componentTheme.headerPadding,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    },
    stimulusContent: {
      height: '100%',
      padding: componentTheme.stimulusContentPadding
    },
    stimulusButtons: {
      flex: '0 0 auto',
      display: 'inline-flex',
      textAlign: 'right',
      zIndex: componentTheme.stimulusButtonsZIndex,
      color: componentTheme.stimulusButtonsColor,
      button: {
        backgroundColor: 'initial'
      }
    },
    optionWrapper: {
      paddingTop: componentTheme.optionPadding
    }
  };
};
export default generateStyle;